'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propType = exports.render = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIs = require('react-is');

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mergeTypes = {
  passive: function passive(originalProps, newProps) {
    return _extends({}, newProps, originalProps);
  },
  aggressive: function aggressive(originalProps, newProps) {
    return newProps;
  },
  none: function none() {
    return {};
  }
};

var defaultOpts = {
  mergeType: 'passive'
};

var render = exports.render = function render(Renderer, props) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _defaultOpts$opts = _extends({}, defaultOpts, opts),
      mergeType = _defaultOpts$opts.mergeType;

  if (process.env.NODE_ENV !== 'production') {
    (0, _invariant2.default)(mergeType === 'passive' || mergeType === 'aggressive' || mergeType === 'none', 'CustomRenderer: invalid merge type (expected aggressive|passive|none, got ' + mergeType + ')');
  }

  if (_react2.default.isValidElement(Renderer)) {
    return (0, _react.cloneElement)(Renderer, mergeTypes[mergeType](Renderer.props, props));
  }

  if ((0, _reactIs.isValidElementType)(Renderer)) {
    return _react2.default.createElement(Renderer, props);
  }

  return Renderer;
};

var propType = exports.propType = _propTypes2.default.oneOfType([_propTypes2.default.elementType, _propTypes2.default.node]);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/utils/propTypes/customRenderer.js
// module id = 88
// module chunks = 177